import { Action } from 'redux'
import { getCreatorForType, toCamelCase, toUpperCase } from './utils'

const stages = ['TRIGGER', 'REQUEST', 'SUCCESS', 'FAILURE', 'FULFILL']
const separator = '/'

export interface IFormAction<P = {}, M = {}> extends Action {
  meta: M
  payload: P
}

export interface ICreateFormActions<P, M = {}> {
  TRIGGER: string
  REQUEST: string
  SUCCESS: string
  FAILURE: string
  FULFILL: string
  trigger: (payload?: P, meta?: M) => IFormAction<P, M>
  request: (payload?: P, meta?: M) => IFormAction<P, M>
  success: (payload?: P, meta?: M) => IFormAction<P, M>
  failure: (payload?: P, meta?: M) => IFormAction<P, M>
  fulfill: (payload?: P, meta?: M) => IFormAction<P, M>
}

function createFormActions<P = {}, M = {}>(
  typePrefix: string,
  payloadCreator: (payload: P) => unknown = i => i,
  metaCreator: (meta: M) => unknown = i => i,
): ICreateFormActions<P, M> {
  const createActionCreator = <A, B>(type: string) => (
    payload: A,
    meta: B,
  ) => ({
    meta: getCreatorForType(type, metaCreator)(meta),
    payload: getCreatorForType(type, payloadCreator)(payload),
    type: `${typePrefix}${separator}${type}`,
  })

  return stages.reduce((result, stage) => {
    result[toCamelCase(stage)] = createActionCreator<P, M>(stage)
    result[toUpperCase(stage)] = `${typePrefix}${separator}${stage}`
    return result
  }, {}) as ICreateFormActions<P, M>
}

export default createFormActions
